import { TenantProfileWorkStation } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useTenantProfileWorkStations = (): {
  workStations: TenantProfileWorkStation[];
  loading: boolean;
} => {
  const { tenantProfileStore } = useStore();
  const { tenantProfileWorkStations, workStationsLoading } = tenantProfileStore;

  useEffect(() => {
    tenantProfileStore.getAllWorkStations({ skipCount: 0, maxResultCount: 50 });

    return () => tenantProfileStore.clearTenantProfileWorkStations();
  }, [tenantProfileStore]);

  return { workStations: tenantProfileWorkStations, loading: workStationsLoading };
};
